import { Link } from "gatsby";
import React from "react";
import { Logo } from "./Icons/Logo";
import { TopNav2 } from "./TopNav2";

function TopNav({ path }) {
  return (
    <>
      <nav className="top--navigation">
        <div className="logo--section">
          <Link to="/">
            <Logo />
            Yaddev
          </Link>
        </div>
        <TopNav2 path={path} />
      </nav>
    </>
  );
}

export { TopNav };
